import {useMutation} from "react-query";
import {AddGroupMemberCommand} from "../../models/group";
import groupMemberService from "../../services/GroupMemberService";

export default function useAddGroupMember() {
   return useMutation((request: AddGroupMemberCommand) => groupMemberService.add(request));
}